
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from '../../components/auth/AuthForm';
import { useAuth } from '../../contexts/AuthContext';

const AuthPage = () => {
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');
  const { isLoading, user, role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we have a redirect parameter
  const params = new URLSearchParams(location.search);
  const redirectTo = params.get('redirect') || '/';  // Default to home page

  useEffect(() => {
    // Only redirect if user is loaded and authenticated
    if (!isLoading && user) {
      console.log('AuthPage: User is authenticated with role:', role);
      
      // If user is logged in and is an admin, redirect to admin dashboard
      if (role === 'admin') {
        console.log('AuthPage: Redirecting to admin dashboard');
        navigate('/admin');
      } else if (redirectTo !== '/admin') {
        // For non-admin users, redirect to the requested page unless it's the admin area
        console.log(`AuthPage: Redirecting to ${redirectTo}`);
        navigate(redirectTo);
      } else {
        console.log('AuthPage: User is not admin but tried to access admin area');
        // Just stay on this page if they tried to access admin
      }
    }
  }, [isLoading, user, role, navigate, redirectTo]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <AuthForm
      mode={mode}
      onModeChange={() => setMode(mode === 'signin' ? 'signup' : 'signin')}
    />
  );
};

export default AuthPage;
